import React from "react";
import AddIcon from "@mui/icons-material/Add";
import useAuth from "src/hooks/useAuth";
import { allowedToCreateEntity } from "src/constants/role";
import Controls from "src/components/form/controls/Controls";
import { Link } from "react-router-dom";
import { path } from "src/constants/path";

const TTSIntentControlPanel = ({ permissionsAccessControl, children }) => {
  const { auth } = useAuth();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
          <div style={{ display: "flex" }}>
            <Link
              to={{
                pathname: `${path.ttsIntent}/add`,
                search: "?eventType=success",
                state: { eventId: null, contextId: null },
              }}
            >
              <Controls.Button
                text="Add New Success Intent"
                variant="outlined"
                startIcon={<AddIcon />}
              />
            </Link>

            <Link
              to={{
                pathname: `${path.ttsIntent}/add`,
                search: "?eventType=error",
                state: { eventId: null, contextId: null },
              }}
            >
              <Controls.Button
                text="Add Error Intent"
                variant="outlined"
                color="warning"
                startIcon={<AddIcon />}
              />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default TTSIntentControlPanel;
